import SettingConfig from '@module/config/setting';
import { createChatBlockCountryUpdate } from '@module/helpers/centrifuge/messageUpdates';
import type { ParsedCentrifugeMessage } from '@module/types/centrifuge/messageTypes';
import {
  type ChatBlockCountryMessage,
  isChatBlockCountryMessage,
} from '@module/types/centrifuge/public-message/ChatBlockCountryMessageTypes';
import type { MessageHandler, MessageHandlerAction, MessageHandlerContext } from '../types';

/**
 * ChatBlockCountry 메시지 처리
 * 특정 국가의 사용자들이 다른 국가의 채팅을 볼 수 없도록 설정
 */
export class ChatBlockCountryHandler implements MessageHandler {
  constructor(private customAction?: MessageHandlerAction<ChatBlockCountryMessage>) {}

  canHandle(payload: ParsedCentrifugeMessage): boolean {
    return isChatBlockCountryMessage(payload);
  }

  handle(payload: ChatBlockCountryMessage, context: MessageHandlerContext): void {
    if (this.customAction === null || this.customAction === undefined) return;
    if (!context.playInfo) return;

    if (typeof this.customAction === 'function') {
      this.customAction(payload, context);
      return;
    }

    // 기본 동작: fromLocale이 현재 환경 LOCALE과 일치하면 playInfo에 차단 정보 갱신
    if (payload.data.message.fromLocale === SettingConfig.LOCALE) {
      context.setPlayInfo(createChatBlockCountryUpdate(payload, context.playInfo));
    }
  }
}
